/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 * Rana simulation API (latest stable version: v3)   Framework release: 3.5.51   Rana simulation core release: 3.7.3   deployed on:  10:12AM (UTC) on September 07, 2026
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface TMS
 */
export interface TMS {
  /**
   *
   */
  tmsUrl: string;
  /**
   *
   */
  minmaxUrl: string;
}

/**
 * Check if a given object implements the TMS interface.
 */
export function instanceOfTMS(value: object): value is TMS {
  if (
    (!("tmsUrl" in (value as Record<string, any>)) &&
      !("tms_url" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["tmsUrl"] === undefined &&
      (value as Record<string, any>)["tms_url"] === undefined)
  )
    return false;
  if (
    (!("minmaxUrl" in (value as Record<string, any>)) &&
      !("minmax_url" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["minmaxUrl"] === undefined &&
      (value as Record<string, any>)["minmax_url"] === undefined)
  )
    return false;
  return true;
}

export function TMSFromJSON(json: any): TMS {
  return TMSFromJSONTyped(json, false);
}

export function TMSFromJSONTyped(json: any, ignoreDiscriminator: boolean): TMS {
  if (json == null) {
    return json;
  }
  return {
    tmsUrl: json["tms_url"],
    minmaxUrl: json["minmax_url"],
  };
}

export function TMSToJSON(json: any): TMS {
  return TMSToJSONTyped(json, false);
}

export function TMSToJSONTyped(value?: TMS | null, ignoreDiscriminator: boolean = false): any {
  if (value == null) {
    return value;
  }

  return {
    tms_url: value["tmsUrl"],
    minmax_url: value["minmaxUrl"],
  };
}
